// MF-67 — Standard field wrapper for Journal forms: label ABOVE the control (one type scale for every
// field, no floating labels mixed with captions), then a hint or error UNDER it, grouped tightly so it
// clearly belongs to this field. `subtitle` (optional) sits right under the label, before the control —
// for instructions on how to fill it. Space BETWEEN fields comes from the parent (FormCard gap).
import { Typography } from '@mui/material'
import HelpTip from './HelpTip'

const FormField = ({ label, subtitle, required, help, hint, error, htmlFor, children }) => (
  <div className='flex flex-col' style={{ gap: 6 }}>
    {label ? (
      <Typography
        component='label'
        htmlFor={htmlFor}
        id={htmlFor ? `${htmlFor}-label` : undefined}
        className='flex items-center'
        style={{ fontSize: 13, fontWeight: 600, lineHeight: '20px', minHeight: 20, color: 'rgb(30, 41, 59)' }}
      >
        {label}
        {required ? <span style={{ color: 'rgb(220, 38, 38)', marginLeft: 2 }}>*</span> : null}
        <HelpTip title={help} />
      </Typography>
    ) : null}
    {subtitle ? (
      <Typography
        component='div'
        style={{
          fontSize: 12,
          lineHeight: 1.45,
          color: 'rgb(71, 85, 105)',
          marginTop: label ? -2 : 0,
          whiteSpace: 'pre-line'
        }}
      >
        {subtitle}
      </Typography>
    ) : null}
    {children}
    {error || hint ? (
      <Typography
        variant='caption'
        component='div'
        style={{ fontSize: 12, lineHeight: 1.45, color: error ? 'rgb(220, 38, 38)' : 'rgb(100, 116, 139)' }}
      >
        {error || hint}
      </Typography>
    ) : null}
  </div>
)

export default FormField
